import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 my-2.5 mx-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-full w-full rounded bg-dark-500" })
], -1)
const _hoisted_3 = { class: "scroll-gutter-stable relative overflow-y-auto" }
const _hoisted_4 = { class: "my-2.5 mx-2 flex items-center p-2" }
const _hoisted_5 = { class: "w-full text-center text-xs" }
const _hoisted_6 = { class: "w-full text-center text-xs" }
const _hoisted_7 = { class: "w-full text-center text-xs" }

import { TranslateKey, useInject } from '@/composables/use-inject';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsAvailabilityHeader',
  setup(__props) {

const translate = useInject(TranslateKey);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(translate)('itemDetails.availability.header.sellCount')), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(translate)('itemDetails.availability.header.onePrice')), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(translate)('itemDetails.availability.header.buyCount')), 1)
      ])
    ])
  ]))
}
}

})